<div class="manage-customers">
    <h2>Manage Customers</h2>
  
    <div *ngIf="loading">Loading customers...</div>
    <div *ngIf="error" class="error">{{ error }}</div>
  
    <table *ngIf="!loading && customers.length > 0" class="table table-striped">
      <thead>
        <tr>
          <th>Customer #</th>
          <th>Email</th>
          <th>Name</th>
          <th>Created At</th>
          <th>Last Update</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let customer of customers">
          <td>{{ customer.customer_id }}</td>
          <td>{{ customer.email }}</td>
          <td>{{ customer.customer_name }}</td>
          <td>{{ customer.created_at | date: 'short' }}</td>
          <td>{{ customer.updated_at | date: 'short' }}</td>
          <td>
            <button class="btn btn-sm btn-primary" (click)="viewCustomerOrders(customer.customer_id)">
              View Orders
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  
    <div *ngIf="!loading && customers.length === 0">
      No customers found.
    </div>
  </div>
  